import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Timer } from 'lucide-react';
export function CountdownBar() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Calculate next Sunday midnight
    const now = new Date();
    const nextSunday = new Date();
    nextSunday.setDate(now.getDate() + (7 - now.getDay()) % 7);
    nextSunday.setHours(23, 59, 59, 999);
    // If today is Sunday, set to next Sunday
    if (now.getDay() === 0 && now.getHours() > 0) {
      nextSunday.setDate(nextSunday.getDate() + 7);
    }
    const timer = setInterval(() => {
      const currentTime = new Date().getTime();
      const distance = nextSunday.getTime() - currentTime;
      if (distance < 0) {
        clearInterval(timer);
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    // Show bar after scroll
    const handleScroll = () => {
      if (window.scrollY > 300) setIsVisible(true);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      clearInterval(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-27">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-[#050510]/95 backdrop-blur-lg border-t border-purple-500/30 py-4 px-4 shadow-[0_-10px_40px_rgba(0,0,0,0.5)]" data-id="element-28">
          <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-29">
            <div className="flex items-center gap-3" data-id="element-30">
              <div className="p-2 bg-red-500/10 rounded-full animate-pulse" data-id="element-31">
                <Timer className="w-5 h-5 text-red-500" data-id="element-32" />
              </div>
              <span className="text-white font-medium" data-id="element-33">
                Oferta disponible solo esta semana
              </span>
            </div>

            <div className="flex items-center gap-4" data-id="element-34">
              <div className="flex gap-2 text-center" data-id="element-35">
                {[{
              label: 'Días',
              value: timeLeft.days
            }, {
              label: 'Hrs',
              value: timeLeft.hours
            }, {
              label: 'Min',
              value: timeLeft.minutes
            }, {
              label: 'Seg',
              value: timeLeft.seconds
            }].map((item, idx) => <div key={idx} className="bg-white/5 rounded px-3 py-1 min-w-[50px]" data-id="element-36">
                    <div className="text-lg font-bold text-purple-400 font-orbitron" data-id="element-37">
                      {String(item.value).padStart(2, '0')}
                    </div>
                    <div className="text-[10px] text-gray-500 uppercase" data-id="element-38">
                      {item.label}
                    </div>
                  </div>)}
              </div>
              <a href="#precios" className="hidden sm:block relative px-6 py-2 rounded-full bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 text-black font-bold text-sm animate-flame-border hover:scale-105 transition-transform duration-300" data-id="element-39">
                🔥 Aprovechar Oferta
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}